module.exports = __webpack_public_path__ + "assets/img/driver-active-btn-be6a91b5.png";